export const ZAInvestmentPortfolioMarkdown = {
    "ZA Long-Term Growth": `ZA Long-Term Growth Portfolio
=============================

Overview:
---------

This is your 'set it and forget it' kind of investment that aims to grow your money over many years. Think of it like planting a tree; it takes time to grow tall and strong. We'll aim to pick investments that have the potential to increase in value over time, but remember, with the chance for higher growth comes higher swings in investment value -- it's all part of the journey towards long-term rewards

Why We Chose This for You:
--------------------------

-   ### Your Situation:

You're in it for the long run, eyeing more than 5 years ahead. You're up for some risks, comfortable taking on more risk for potentially higher returns, not overly stressed about the climate impact within your investments, and ready to invest $5,000 or more.

-   ### Why This Fits for You:

You're a forward-thinker, balancing between the bold moves of youth and the wisdom of experience. This portfolio mirrors that balance: it's designed for those who aren't afraid to aim high but understand the value of time in achieving success. We matched you here because you're all about setting ambitious goals while being smart about the long game.

FAQs:
-----

1.  ### What is this portfolio about?

It's like planting a seed for your financial future; we aim to grow your money over a long time, through ups and downs.

2.  ### Who should choose this portfolio?

If you're not in a hurry and want your investments to grow over the years, this might be the right choice for you.`,
    "ZA Long-Term Conservative/Defensive": `ZA Long-Term Conservative/Defensive Portfolio
=============================================

Overview:
---------

Imagine this as your safety net. It's designed to help protect your money from big market ups and downs while still giving you the opportunity to grow your savings slowly and steadily. It's like having a guardrail while you're hiking up a hill -- it helps keep you safe, especially when the path gets a bit rock

Why We Chose This for You: 
---------------------------

-   ### Your Situation:

You've got a long horizon over 5 years and prefer a steadier, safer journey (think gentle hikes over rock climbing), have lighter concerns about the climate, and are investing $5,000 or more.

-   ### Why This Fits for You:

Because you like to keep things more balanced and safer, we've picked a portfolio that matches your steady approach, helping your investment grow at a calmer pace while still moving forward.

FAQs:
-----

1.  ### What does this portfolio do?

Think of it as a protective bubble for your money, aiming to keep it safe while gently growing it over time.

2.  ### Is this portfolio right for me?

If you prefer a safer path and are okay with slower, steady growth, this could be your match.`,
    "ZA Climate Transition (LT)": `ZA Climate Transition (LT) Portfolio
====================================

Overview:
---------

This portfolio is all about investing in a better future. We focus on companies that are helping to fight climate change or are making big changes to be more environment-friendly. By investing here, you're not just looking after your own future; you're helping to ensure a healthier planet for generations to come.

Why We Chose This for You: 
---------------------------

-   ### Your Situation:

You're dedicated to investing over the long term, willing to embrace some risks, deeply concerned about climate change, and ready to invest $5,000 or more.

-   ### Why This Fits for You:

Your passion for the planet shines through, so we've matched you with a portfolio that not only looks to grow your wealth but also aligns with your green convictions, aiming to make a positive impact on the world.

FAQs:
-----

1.  ### What's the focus here?

Investing in companies leading the charge against climate change for a better, greener future.

2.  ### Who should invest in this portfolio?

If you're passionate about the environment and want your money to reflect that, this is for you.`,
    "ZA Long-Term Low Min": `ZA Long-Term Low Min Portfolio
==============================

Overview:
---------

Think of this as your starting point in the investment world. It's designed for those who are new to investing or don't want to put in a lot of money right away. We'll help you get your feet wet without diving into the deep end, aiming for long-term growth with a smaller initial investment

Why We Chose This for You: 
---------------------------

-   ### Your Situation:

You're in for the long haul (over 5 years) but prefer to tread carefully with your investments or are starting with a smaller amount. Your climate concerns vary, but you're mindful about starting out.

-   ### Why This Fits for You:

Since you're looking for a safer start or have a bit less to invest, we've chosen a portfolio that lets you step into the investment world with a gentle approach, perfect for building confidence as you go.

FAQs:
-----

1.  ### What is special about this portfolio?

It's an entry-level investment option, perfect for getting started without a big commitment.

2.  ### Who is this best suited for?

New investors or those with less money to start with but interested in long-term growth.`,
    "ZA Short-Term Growth": `ZA Short-Term Growth Portfolio
==============================

Overview:
---------

This is for when you're looking for a quicker return on your investment, kind of like a short sprint instead of a long marathon. We'll aim for growth, but since we're moving faster, be prepared for a bit more bumpiness along the way. It's perfect if you're planning for a goal that's just a few years away

Why We Chose This for You: 
---------------------------

-   ### Your Situation:

Your time frame is a bit shorter, between 2 to 5 years, you're ready for a faster-paced investment, and you're looking to invest $5,000 or more.

-   ### Why This Fits for You:

You want to move a bit quicker without waiting years. We've selected a portfolio that seeks to grow your investment in a shorter time, matching your timeline and energy.

FAQs:
-----

1.  ### What is this portfolio aiming for?

It's about growing your money quicker than usual, with a focus on a shorter time frame.

2.  ### Who should pick this portfolio?

If you have a financial goal that's just a few years away, this could help you get there faster.`,
    "ZA Short-Term Conservative": `ZA Short-Term Conservative Portfolio
====================================

Overview:
---------

This one's like keeping your money in a safer spot when you know you'll need it soon. It's all about protecting your savings while still giving them a chance to grow a bit, but without the big swings. It's perfect if you're saving for something in the near future, like a dream vacation or a new car

Why We Chose This for You: 
---------------------------

-   ### Your Situation:

You're looking to invest over a very short term (0-2 years), prefer to stick to the safer side of the road, and have $5,000 or more to invest.

-   ### Why This Fits for You:

You're all about keeping things low-risk, especially with a shorter time frame. We've picked a portfolio that aims to protect your investment while offering a chance for some growth without the wild ride.

FAQs:
-----

1.  ### What's the goal of this portfolio?

To keep your investment safer while still aiming for some growth, especially if you'll need your money soon.

2.  ### Should I consider this portfolio?

If you're saving for something in the near term and want to keep risks low, yes!`,
    "ZA Short-Term Low Min": `ZA Short-Term Low Min Portfolio
===============================

Overview:
---------

Here's your chance to dip your toes into investing without jumping all in. It's perfect for trying out short-term investing without needing a lot of money upfront. Think of it as your trial run in the investment world, aiming for some growth without the long-term commitment

Why We Chose This for You: 
---------------------------

-   ### Your Situation:

You're planning to invest for up to 5 years, prefer to keep things on the very safe side, and might be starting with less than $5,000.

-   ### Why This Fits for You:

You're stepping into the investing pool with care, so we've chosen a gentle introduction that suits your shorter timeline and budget, helping you start off on the right foot without diving too deep.

FAQs:
-----

1.  ### What makes this portfolio unique?

It's a low-risk, short-term investment starter pack, needing less money to begin.

2.  ### Who should try this out?

Anyone new to investing or looking to invest a smaller amount for the short term.`
};

export const ZAInvestmentPortfolioDefinitions = {
  "ZA Long-Term Growth": {
    "Overview": "This is your 'set it and forget it' kind of investment that aims to grow your money over many years. Think of it like planting a tree; it takes time to grow tall and strong. We'll aim to pick investments that have the potential to increase in value over time, but remember, with the chance for higher growth comes higher swings in investment value -- it's all part of the journey towards long-term rewards.",
    "Why We Chose This for You": {
      "Your Situation": "You're in it for the long run, eyeing more than 5 years ahead. You're up for some risks, comfortable taking on more risk for potentially higher returns, not overly stressed about the climate impact within your investments, and ready to invest $5,000 or more.",
      "Why This Fits for You": "You're a forward-thinker, balancing between the bold moves of youth and the wisdom of experience. This portfolio mirrors that balance: it's designed for those who aren't afraid to aim high but understand the value of time in achieving success. We matched you here because you're all about setting ambitious goals while being smart about the long game."
    },
    "FAQs": {
      "What is this portfolio about?": "It's like planting a seed for your financial future; we aim to grow your money over a long time, through ups and downs.",
      "Who should choose this portfolio?": "If you're not in a hurry and want your investments to grow over the years, this might be the right choice for you."
    }
  },
  "ZA Long-Term Conservative/Defensive": {
    "Overview": "Imagine this as your safety net. It's designed to help protect your money from big market ups and downs while still giving you the opportunity to grow your savings slowly and steadily. It's like having a guardrail while you're hiking up a hill -- it helps keep you safe, especially when the path gets a bit rocky.",
    "Why We Chose This for You": {
      "Your Situation": "You've got a long horizon over 5 years and prefer a steadier, safer journey (think gentle hikes over rock climbing), have lighter concerns about the climate, and are investing $5,000 or more.",
      "Why This Fits for You": "Because you like to keep things more balanced and safer, we've picked a portfolio that matches your steady approach, helping your investment grow at a calmer pace while still moving forward."
    },
    "FAQs": {
      "What does this portfolio do?": "Think of it as a protective bubble for your money, aiming to keep it safe while gently growing it over time.",
      "Is this portfolio right for me?": "If you prefer a safer path and are okay with slower, steady growth, this could be your match."
    }
  },
  "ZA Climate Transition (LT)": {
    "Overview": "This portfolio is all about investing in a better future. We focus on companies that are helping to fight climate change or are making big changes to be more environment-friendly. By investing here, you're not just looking after your own future; you're helping to ensure a healthier planet for generations to come.",
    "Why We Chose This for You": {
      "Your Situation": "You're dedicated to investing over the long term, willing to embrace some risks, deeply concerned about climate change, and ready to invest $5,000 or more.",
      "Why This Fits for You": "Your passion for the planet shines through, so we've matched you with a portfolio that not only looks to grow your wealth but also aligns with your green convictions, aiming to make a positive impact on the world."
    },
    "FAQs": {
      "What's the focus here?": "Investing in companies leading the charge against climate change for a better, greener future.",
      "Who should invest in this portfolio?": "If you're passionate about the environment and want your money to reflect that, this is for you."
    }
  },
  "ZA Long-Term Low Min": {
    "Overview": "Think of this as your starting point in the investment world. It's designed for those who are new to investing or don't want to put in a lot of money right away. We'll help you get your feet wet without diving into the deep end, aiming for long-term growth with a smaller initial investment.",
    "Why We Chose This for You": {
      "Your Situation": "You're in for the long haul (over 5 years) but prefer to tread carefully with your investments or are starting with a smaller amount. Your climate concerns vary, but you're mindful about starting out.",
      "Why This Fits for You": "Since you're looking for a safer start or have a bit less to invest, we've chosen a portfolio that lets you step into the investment world with a gentle approach, perfect for building confidence as you go."
    },
    "FAQs": {
      "What is special about this portfolio?": "It's an entry-level investment option, perfect for getting started without a big commitment.",
      "Who is this best suited for?": "New investors or those with less money to start with but interested in long-term growth."
    }
  },
  "ZA Short-Term Growth": {
    "Overview": "This is for when you're looking for a quicker return on your investment, kind of like a short sprint instead of a long marathon. We'll aim for growth, but since we're moving faster, be prepared for a bit more bumpiness along the way. It's perfect if you're planning for a goal that's just a few years away.",
    "Why We Chose This for You": {
      "Your Situation": "Your time frame is a bit shorter, between 2 to 5 years, you're ready for a faster-paced investment, and you're looking to invest $5,000 or more.",
      "Why This Fits for You": "You want to move a bit quicker without waiting years. We've selected a portfolio that seeks to grow your investment in a shorter time, matching your timeline and energy."
    },
    "FAQs": {
      "What is this portfolio aiming for?": "It's about growing your money quicker than usual, with a focus on a shorter time frame.",
      "Who should pick this portfolio?": "If you have a financial goal that's just a few years away, this could help you get there faster."
    }
  },
  "ZA Short-Term Conservative": {
    "Overview": "This one's like keeping your money in a safer spot when you know you'll need it soon. It's all about protecting your savings while still giving them a chance to grow a bit, but without the big swings. It's perfect if you're saving for something in the near future, like a dream vacation or a new car.",
    "Why We Chose This for You": {
      "Your Situation": "You're looking to invest over a very short term (0-2 years), prefer to stick to the safer side of the road, and have $5,000 or more to invest.",
      "Why This Fits for You": "You're all about keeping things low-risk, especially with a shorter time frame. We've picked a portfolio that aims to protect your investment while offering a chance for some growth without the wild ride."
    },
    "FAQs": {
      "What's the goal of this portfolio?": "To keep your investment safer while still aiming for some growth, especially if you'll need your money soon.",
      "Should I consider this portfolio?": "If you're saving for something in the near term and want to keep risks low, yes!"
    }
  },
  "ZA Short-Term Low Min": {
    "Overview": "Here's your chance to dip your toes into investing without jumping all in. It's perfect for trying out short-term investing without needing a lot of money upfront. Think of it as your trial run in the investment world, aiming for some growth without the long-term commitment.",
    "Why We Chose This for You": {
      "Your Situation": "You're planning to invest for up to 5 years, prefer to keep things on the very safe side, and might be starting with less than $5,000.",
      "Why This Fits for You": "You're stepping into the investing pool with care, so we've chosen a gentle introduction that suits your shorter timeline and budget, helping you start off on the right foot without diving too deep."
    },
    "FAQs": {
      "What makes this portfolio unique?": "It's a low-risk, short-term investment starter pack, needing less money to begin.",
      "Who should try this out?": "Anyone new to investing or looking to invest a smaller amount for the short term."
    }
  }
};

export const ZAInvestmentPortfolioDefinitions2026 = {
  "portfolio_overview": {
    "description": "Each ZA portfolio is designed with distinct objectives and risk profiles to match specific investor needs and time horizons. All portfolios utilize low-cost Calvert funds and select ESG-focused holdings to maintain values alignment while maximizing cost efficiency. These streamlined portfolios provide professional-grade asset allocation without management fees.",
    "comparison_summary": [
      {
        "metric": "# Holdings",
        "LT Growth": "4",
        "LT Defensive": "5",
        "Climate Transition": "6",
        "LT Low Min": "3",
        "ST Equity": "2",
        "ST Defensive": "3",
        "ST Low Min": "2"
      },
      {
        "metric": "Equity",
        "LT Growth": "60%",
        "LT Defensive": "55%",
        "Climate Transition": "60%",
        "LT Low Min": "60%",
        "ST Equity": "100%",
        "ST Defensive": "20%",
        "ST Low Min": "0%"
      },
      {
        "metric": "FI",
        "LT Growth": "40%",
        "LT Defensive": "45%",
        "Climate Transition": "40%",
        "LT Low Min": "40%",
        "ST Equity": "0%",
        "ST Defensive": "80%",
        "ST Low Min": "100%"
      },
      {
        "metric": "Risk Level",
        "LT Growth": "Moderate",
        "LT Defensive": "Below market",
        "Climate Transition": "Moderate",
        "LT Low Min": "Moderate",
        "ST Equity": "Market",
        "ST Defensive": "Conservative",
        "ST Low Min": "Very conservative"
      },
      {
        "metric": "ESG",
        "LT Growth": "Screening",
        "LT Defensive": "Screening",
        "Climate Transition": "Thematic",
        "LT Low Min": "Screening",
        "ST Equity": "Screening",
        "ST Defensive": "Screening",
        "ST Low Min": "Screening"
      },
      {
        "metric": "Volatility",
        "LT Growth": "Moderate",
        "LT Defensive": "Lower",
        "Climate Transition": "Moderate",
        "LT Low Min": "Moderate",
        "ST Equity": "Higher",
        "ST Defensive": "Low",
        "ST Low Min": "Very low"
      }
    ]
  },
  "portfolios": {
    "ZA Long-Term Growth Portfolio": {
      "portfolio_name": "ZA Long-Term Growth Portfolio",
      "overview": "The ZA Long-Term Growth Portfolio is designed for investors seeking balanced growth with moderate risk through a diversified mix of U.S. and international equities combined with investment-grade bonds. This 60/40 equity-to-fixed income allocation provides the classic balanced portfolio structure that has served long-term investors for decades, enhanced with ESG screening.",
      "ideal_for": [
        "Those seeking balanced growth and income",
        "First-time investors wanting diversification across asset classes",
        "Those prioritizing cost efficiency with professional allocation"
      ],
      "Why We Chose This for You": {
        "Your Situation": "You're in it for the long run, eyeing more than 5 years ahead. You're up for some risks, comfortable taking on more risk for potentially higher returns, not overly stressed about the climate impact within your investments, and ready to invest $5,000 or more.",
        "Why This Fits for You": "You're a forward-thinker, balancing between the bold moves of youth and the wisdom of experience. This portfolio mirrors that balance: it's designed for those who aren't afraid to aim high but understand the value of time in achieving success."
      },
      "FAQs": {
        "What is this portfolio about?": "It's like planting a seed for your financial future; we aim to grow your money over a long time, through ups and downs.",
        "Who should choose this portfolio?": "If you’re not in a hurry and want your investments to grow over the years, this might be the right choice for you."
      },
      "investment_philosophy": "Classic balanced portfolio approach utilizing broad market index exposure across U.S. and international equities, complemented by investment-grade bonds and short-duration securities.",
      "holdings": [
        { "ticker": "CVLC", "allocation": "40%" },
        { "ticker": "CVIE", "allocation": "20%" },
        { "ticker": "NUBD", "allocation": "30%" },
        { "ticker": "CVSB", "allocation": "10%" }
      ],
      "key_characteristics": [
        "Classic 60/40 equity-to-bond allocation",
        "Broad U.S. and international diversification",
        "ESG screening across all holdings",
        "Mix of growth and income generation"
      ],
      "expected_behavior": [
        "Target: Capture 60-70% of equity market upside, 40-50% of market downside",
        "Bond allocation cushions equity drawdowns",
        "Consistent income generation from fixed income holdings",
        "Long-term growth with reduced volatility"
      ],
      "risk_considerations": [
        "Interest rate sensitivity from bond holdings",
        "Currency exposure from international equities",
        "Bond portion vulnerable to rising interest rates"
      ],
      "investment_thesis": "The 60/40 portfolio has proven itself over decades as the gold standard for balanced investing. By combining equity growth potential with bond market stability, investors gain participation in wealth creation while maintaining a cushion against severe market downturns."
    },
    "ZA Long-Term Defensive Portfolio": {
      "portfolio_name": "ZA Long-Term Defensive Portfolio",
      "overview": "The ZA Long-Term Defensive Portfolio is engineered for conservative investors who want equity market participation but prioritize capital preservation and stability above maximum growth. With 55% in equities and 45% in bonds, this portfolio emphasizes downside protection while maintaining sufficient equity exposure for long-term growth.",
      "ideal_for": [
        "Conservative to moderately conservative risk tolerance",
        "Investors prioritizing stability over maximum returns",
        "Those who would be distressed by 15%+ portfolio declines",
        "Investors wanting equity participation with significant downside cushioning"
      ],
      "Why We Chose This for You": {
        "Your Situation": "You've got a long horizon over 5 years and prefer a steadier, safer journey (think gentle hikes over rock climbing), have lighter concerns about the climate, and are investing $5,000 or more.",
        "Why This Fits for You": "Because you like to keep things more balanced and safer, we’ve picked a portfolio that matches your steady approach, helping your investment grow at a calmer pace while still moving forward."
      },
      "FAQs": {
        "What is this portfolio about?": "Think of it as a protective bubble for your money, aiming to keep it safe while gently growing it over time.",
        "Who should choose this portfolio?": "If you prefer a safer path and are okay with slower, steady growth, this could be your match."
      },
      "investment_philosophy": "Conservative asset allocation emphasizing capital preservation through higher fixed income exposure, combined with quality-focused equity holdings designed to reduce volatility.",
      "holdings": [
        { "ticker": "CVLC", "allocation": "25%" },
        { "ticker": "NULV", "allocation": "15%" },
        { "ticker": "CVIE", "allocation": "15%" },
        { "ticker": "NUBD", "allocation": "35%" },
        { "ticker": "CVSB", "allocation": "10%" }
      ],
      "key_characteristics": [
        "Balanced 55% equity / 45% fixed income allocation",
        "Quality and value emphasis in equity holdings",
        "Higher bond allocation for stability",
        "ESG screening across all holdings",
        "Focus on capital preservation with growth potential"
      ],
      "expected_behavior": [
        "Target: Capture 50-60% of equity market upside, 35-45% of market downside",
        "Lower volatility than balanced portfolios",
        "Significant cushioning during market downturns",
        "Outperformance during bear markets relative to equity-heavy portfolios"
      ],
      "risk_considerations": [
        "Interest rate sensitivity from 45% bond allocation",
        "May not keep pace with inflation over very long periods",
        "Currency exposure from international holdings"
      ],
      "investment_thesis": "For investors with shorter time horizons or lower risk tolerance, preserving capital is paramount. By allocating 45% to fixed income and emphasizing quality within the 55% equity allocation, this portfolio balances stability with meaningful participation in equity market growth."
    },
    "ZA Climate Transition Portfolio": {
      "portfolio_name": "ZA Climate Transition Portfolio",
      "overview": "The ZA Climate Transition Portfolio is purpose-built for investors who view the global shift to a low-carbon economy as a defining investment opportunity while maintaining a balanced risk profile through fixed income exposure.",
      "ideal_for": [
        "Investors who see climate transition as a major investment opportunity",
        "Desire to align investments with climate action",
        "Willingness to accept thematic concentration with bond cushioning",
        "Investors seeking impact alongside returns"
      ],
      "Why We Chose This for You": {
        "Your Situation": "You're dedicated to investing over the long term, willing to embrace some risks, deeply concerned about climate change, and ready to invest $5,000 or more.",
        "Why This Fits for You": "Your passion for the planet shines through, so we’ve matched you with a portfolio that not only looks to grow your wealth but also aligns with your green convictions."
      },
      "FAQs": {
        "What is this portfolio about?": "Investing in companies leading the charge against climate change for a better, greener future.",
        "Who should choose this portfolio?": "If you’re passionate about the environment and want your money to reflect that, this is for you."
      },
      "investment_philosophy": "Strategic allocation to climate solutions and environmental markets balanced with investment-grade fixed income for stability. Concentrates equity exposure in companies enabling decarbonization, renewable energy, water sustainability, and climate adaptation.",
      "holdings": [
        { "ticker": "CVLC", "allocation": "25%" },
        { "ticker": "CVIE", "allocation": "10%" },
        { "ticker": "ERTH", "allocation": "15%" },
        { "ticker": "FIW", "allocation": "10%" },
        { "ticker": "NUBD", "allocation": "30%" },
        { "ticker": "CVSB", "allocation": "10%" }
      ],
      "key_characteristics": [
        "Balanced 60% equity / 40% fixed income structure",
        "Concentrated climate theme in equity allocation",
        "Global environmental markets exposure",
        "Water infrastructure and technology focus",
        "Bond allocation manages thematic concentration risk",
        "ESG screening across all holdings"
      ],
      "expected_behavior": [
        "Target: Performance tied to climate policy adoption and clean energy economics",
        "Moderate volatility from bond cushioning of thematic equity",
        "Potential for outperformance as climate transition accelerates",
        "Income generation from bond allocation",
        "May underperform during fossil fuel rallies"
      ],
      "risk_considerations": [
        "Thematic concentration in climate-related sectors",
        "Performance dependent on climate policy and regulation",
        "Sector-specific risks in utilities, infrastructure, and environmental markets",
        "Interest rate sensitivity from bond holdings"
      ],
      "investment_thesis": "The transition to a low-carbon economy represents a multi-trillion-dollar infrastructure transformation. By combining concentrated climate equity exposure with stabilizing bond holdings, this portfolio allows investors to express climate conviction while managing volatility."
    },
    "ZA Long-Term Low Minimum Portfolio": {
      "portfolio_name": "ZA Long-Term Low Minimum Portfolio",
      "overview": "The ZA Long-Term Low Minimum Portfolio is designed for investors starting their journey with smaller account balances who want a professionally structured balanced allocation. This streamlined three-fund portfolio provides comprehensive diversification across U.S. equities, international equities, and investment-grade bonds.",
      "ideal_for": [
        "Those seeking maximum simplicity with professional allocation",
        "First-time investors wanting balanced exposure",
        "Investors prioritizing cost efficiency above all else",
        "Those building initial investment portfolios"
      ],
      "Why We Chose This for You": {
        "Your Situation": "You're in for the long haul (over 5 years) but prefer to tread carefully with your investments or are starting with a smaller amount. Your climate concerns vary, but you're mindful about starting out.",
        "Why This Fits for You": "Since you're looking for a safer start or have a bit less to invest, we've chosen a portfolio that lets you step into the investment world with a gentle approach."
      },
      "FAQs": {
        "What is this portfolio about?": "It’s an entry-level investment option, perfect for getting started without a big commitment.",
        "Who should choose this portfolio?": "New investors or those with less money to start with but interested in long-term growth."
      },
      "investment_philosophy": "Simplified balanced portfolio approach using the minimum number of holdings necessary for comprehensive diversification. Passive index exposure across U.S. equities, international equities, and bonds.",
      "holdings": [
        { "ticker": "CVLC", "allocation": "50%" },
        { "ticker": "CVIE", "allocation": "10%" },
        { "ticker": "NUBD", "allocation": "40%" }
      ],
      "key_characteristics": [
        "Classic 60/40 equity-to-bond allocation",
        "Broad U.S. and international equity diversification",
        "ESG screening across all holdings"
      ],
      "expected_behavior": [
        "Target: Capture 60-70% of equity market upside, 40-50% of market downside",
        "Moderate volatility from balanced allocation",
        "Bond allocation cushions equity drawdowns",
        "Long-term growth with managed risk"
      ],
      "risk_considerations": [
        "Interest rate sensitivity from 40% bond allocation",
        "Limited diversification compared to more complex portfolios",
        "Market risk from 60% equity allocation"
      ],
      "investment_thesis": "By using just three low-cost funds to achieve full diversification, this portfolio provides professional-grade allocation. The simplified structure reduces costs and makes additional allocations straightforward."
    },
    "ZA Short-Term Equity Portfolio": {
      "portfolio_name": "ZA Short-Term Equity Portfolio",
      "overview": "The ZA Short-Term Equity Portfolio is designed for investors with 1-3 year time horizons who want equity market exposure without the complexity or cost of active management. This 100% equity allocation provides maximum growth potential in the near-to-medium term.",
      "ideal_for": [
        "Aggressive risk tolerance despite short timeframe",
        "Those willing to delay goals if markets decline",
        "Investors who would add more capital during market declines",
        "Those seeking maximum cost efficiency with equity exposure"
      ],
      "Why We Chose This for You": {
        "Your Situation": "Your time frame is a bit shorter, between 2 to 5 years, you're ready for a faster-paced investment, and you're looking to invest $5,000 or more.",
        "Why This Fits for You": "You want to move a bit quicker without waiting years. We've selected a portfolio that seeks to grow your investment in a shorter time, matching your timeline and energy."
      },
      "FAQs": {
        "What is this portfolio about?": "It's about growing your money quicker than usual, with a focus on a shorter time frame.",
        "Who should choose this portfolio?": "If you have a financial goal that’s just a few years away, this could help you get there faster."
      },
      "investment_philosophy": "Pure equity exposure through passive index strategies across U.S. and international markets. Accepting volatility risk in pursuit of equity market returns.",
      "holdings": [
        { "ticker": "CVLC", "allocation": "70%" },
        { "ticker": "CVIE", "allocation": "30%" }
      ],
      "key_characteristics": [
        "100% equity allocation for maximum growth",
        "Broad U.S. and international diversification",
        "ESG screening across both holdings",
        "High liquidity for goal-based withdrawals"
      ],
      "expected_behavior": [
        "Target: Full participation in global equity market returns",
        "High volatility from 100% equity allocation",
        "Potential for 20-30%+ declines in adverse markets",
        "No income generation focus"
      ],
      "risk_considerations": [
        "100% equity",
        "May force goal delay or capital loss if withdrawal needed during downturn",
        "No downside protection from bonds or cash",
        "Sequence-of-returns risk for short timeframes"
      ],
      "investment_thesis": "This strategy only makes sense for investors who can genuinely delay their goal if markets decline significantly. This portfolio acknowledges that some investors prefer equity market upside potential over the certainty of bonds."
    },
    "ZA Short-Term Defensive Portfolio": {
      "portfolio_name": "ZA Short-Term Defensive Portfolio",
      "overview": "The ZA Short-Term Defensive Portfolio is designed for conservative investors with 1-3 year time horizons who prioritize capital preservation while accepting minimal equity exposure for modest growth potential. 80% fixed income and 20% equities.",
      "ideal_for": [
        "Conservative to very conservative risk tolerance",
        "Those who cannot afford principal loss",
        "Near-term major expenses (home purchase, tuition, retirement transition)",
        "Emergency reserves with modest growth objective"
      ],
      "Why We Chose This for You": {
        "Your Situation": "You’re looking to invest over a very short term (0-2 years), prefer to stick to the safer side of the road, and have $5,000 or more to invest.",
        "Why This Fits for You": "You’re all about keeping things low-risk, especially with a shorter time frame. We’ve picked a portfolio that aims to protect your investment while offering a chance for some growth."
      },
      "FAQs": {
        "What is this portfolio about?": "To keep your investment safer while still aiming for some growth, especially if you’ll need your money soon.",
        "Who should choose this portfolio?": "If you’re saving for something in the near term and want to keep risks low, yes!"
      },
      "investment_philosophy": "Capital preservation through dominant fixed income allocation combined with minimal equity exposure for growth enhancement. Ultra-short duration holdings provide liquidity and rate protection.",
      "holdings": [
        { "ticker": "CVLC", "allocation": "20%" },
        { "ticker": "NUBD", "allocation": "50%" },
        { "ticker": "CVSB", "allocation": "30%" }
      ],
      "key_characteristics": [
        "Very conservative 20% equity / 80% fixed income allocation",
        "High liquidity from 30% ultra-short duration allocation",
        "Income generation focus",
        "Capital preservation emphasis",
        "ESG screening across all holdings"
      ],
      "expected_behavior": [
        "Target: Minimal volatility with modest returns above cash",
        "Strong downside protection during market stress",
        "Consistent income generation",
        "Minimal drawdowns even in severe markets"
      ],
      "risk_considerations": [
        "Limited growth potential",
        "May struggle to outpace inflation over time",
        "Opportunity cost versus higher-returning portfolios"
      ],
      "investment_thesis": "For investors with true short-term horizons, capital preservation must be primary. By allocating 80% to fixed income, this portfolio prioritizes stability while a small 20% equity allocation provides modest growth potential."
    },
    "ZA Short-Term Low Minimum Portfolio": {
      "portfolio_name": "ZA Short-Term Low Minimum Portfolio",
      "overview": "The ZA Short-Term Low Minimum Portfolio is designed for investors with near-term liquidity needs who want income generation and capital stability without equity market risk. This is a 100% fixed income allocation.",
      "ideal_for": [
        "Very conservative to conservative risk tolerance",
        "Near-term major expenses requiring certainty",
        "Those who cannot tolerate equity volatility",
        "Cash-like stability with enhanced income"
      ],
      "Why We Chose This for You": {
        "Your Situation": "You're planning to invest for up to 5 years, prefer to keep things on the very safe side, and might be starting with less than $5,000.",
        "Why This Fits for You": "You're stepping into the investing pool with care, so we’ve chosen a gentle introduction that suits your shorter timeline and budget."
      },
      "FAQs": {
        "What is this portfolio about?": "It’s a low-risk, short-term investment starter pack, needing less money to begin.",
        "Who should choose this portfolio?": "Anyone new to investing or looking to invest a smaller amount for the short term."
      },
      "investment_philosophy": "Pure fixed income approach emphasizing capital preservation and liquidity through investment-grade bonds and ultra-short duration securities. No equity exposure eliminates volatility.",
      "holdings": [
        { "ticker": "NUBD", "allocation": "80%" },
        { "ticker": "CVSB", "allocation": "20%" }
      ],
      "key_characteristics": [
        "100% fixed income allocation",
        "ESG screening across both holdings",
        "Ultra-simplified two-fund structure",
        "Minimal volatility"
      ],
      "expected_behavior": [
        "Target: Consistent income with minimal principal volatility",
        "Returns above money market funds",
        "No equity market participation",
        "Stable income stream",
        "Protection during equity market stress"
      ],
      "risk_considerations": [
        "Will underperform during equity bull markets",
        "Limited growth potential",
        "May not keep pace with inflation over time"
      ],
      "investment_thesis": "For short-term needs or emergency reserves, eliminating equity exposure is appropriate. This portfolio provides returns superior to money markets while maintaining the capital preservation necessary for near-term goals."
    }
  },
  "holding_definitions": {
    "CVLC": {
      "fund_name": "Calvert U.S. Large-Cap Core Responsible Index ETF",
      "description": "Core U.S. large-cap equity exposure with ESG integration. Tracks an index of the largest U.S. companies meeting environmental, social, and governance standards."
    },
    "CVIE": {
      "fund_name": "Calvert International Responsible Index ETF",
      "description": "International developed market equity exposure with ESG screening. Invests in large and mid-cap companies across Europe, Asia, and other developed markets outside the U.S."
    },
    "NUBD": {
      "fund_name": "Nuveen ESG US Aggregate Bond Fund",
      "description": "Broad U.S. investment-grade bond exposure with ESG screening, tracking the Bloomberg MSCI U.S. Aggregate ESG Select Index across Treasuries, corporates, mortgage-backed, and asset-backed securities."
    },
    "CVSB": {
      "fund_name": "Calvert Ultra-Short Investment Grade ETF",
      "description": "Ultra-short duration investment-grade bonds with weighted average maturity under one year. Provides enhanced cash-like liquidity with minimal interest rate sensitivity."
    },
    "NULV": {
      "fund_name": "Nuveen ESG Large Cap Value ETF",
      "description": "U.S. large-cap value equity exposure with rigorous ESG screening. This strategy provides a diversified tilt toward undervalued domestic companies."
    },
    "ERTH": {
      "fund_name": "Invesco MSCI Sustainable Future ETF",
      "description": "Global equity exposure concentrated in companies deriving revenue from environmentally sustainable business lines, including alternative energy and pollution prevention."
    },
    "FIW": {
      "fund_name": "First Trust Water ETF",
      "description": "Invests in companies deriving substantial revenue from water-related businesses including utilities, infrastructure, purification, and technology."
    }
  }
};